import React, { useEffect, useState } from 'react'
import { CoherentScreen, CoherentScreenProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import * as modelProps from 'models/coherentScreen/coherentScreen-property-definitions'
import utils from 'features/coherentScreen/coherentScreen-util'
import validations from 'features/coherentScreen/coherentScreen-validation'

export interface CoherentScreenProps {
    BuildList?: (
        page: any,
        name: CoherentScreenProperties,
        form: CoherentScreen,
    ) => JSX.Element[]
    page?: any
    title?: any
    form?: CoherentScreen
    onUpdate?: (form: CoherentScreen, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function CoherentScreenForm(props: CoherentScreenProps) {
    let [form, setForm] = useState({} as CoherentScreen)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as CoherentScreen)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as CoherentScreen)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<CoherentScreen, CoherentScreenProperties> | any = {
        ...utils,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.CoherentScreenProperties.Id,
                modelProps.CoherentScreenProperties.Deleted,
                modelProps.CoherentScreenProperties.Version,
                modelProps.CoherentScreenProperties.Created,
                modelProps.CoherentScreenProperties.Updated,
                modelProps.CoherentScreenProperties.Owner,
                modelProps.CoherentScreenProperties.ProcessedSeries,
                modelProps.CoherentScreenProperties.ProcessedMedia,
                modelProps.CoherentScreenProperties.CuratedMediaLists,
                modelProps.CoherentScreenProperties.CuratedSeriesLists,
                modelProps.CoherentScreenProperties.LastUpdatedBy,
                modelProps.CoherentScreenProperties.OrderedReferenceList,
                modelProps.CoherentScreenProperties.HighlightSeriesId
            ].includes(x.name))
        },
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        BuildList: (page, name: CoherentScreenProperties, form: CoherentScreen) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: CoherentScreen,
            property: CoherentScreenProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: CoherentScreenProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>
            {BuildForm<CoherentScreen, CoherentScreenProperties>(args)}
        </React.Fragment>
    )
}
